import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickConvertToLoan = (e) => {
    performCellDoubleClick(e, ApplicationActionType.ConvertToLoan);
};
